import React, { useEffect, useState, useRef } from 'react'
import A12Y_CONST from "../common/a12yConst";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { dateFromKeyboard, ddmmyyyyFormat } from "../util/date_format";
import { downloadBase64File } from "../util/Common";
import moment from 'moment';
import PopUpIncomeExpComponent from '../components/PopUpIncomeExpComponent'
import viewIcon from '../assets/images/viewIcon.svg'
import ErrorMessageComponent from "./ErrorMessageComponent";
import SuccessMessageComponent from "./SuccessMessageComponent";
import { readOnlyMobile } from "../util/inputKeyboardHide";
import { amoutWithoutDecimal } from '../util/date_format'
import { secureClient } from "../config/axiosClient";
import LoaderFullScreen from "./LoaderFullScreenComponent";
import Multiselect from "multiselect-react-dropdown";
import { useDispatch } from 'react-redux';
import { getExpenseTypeList } from '../redux/actions/dependentActions';
import { useHistory } from 'react-router-dom';
import DownloadPopupComponent from './DownloadPopupComponent'
import ReportProcessingPopupComponent from './ReportProcessingPopupComponent'

function ExpenseListComponent(props) {
	const dispatch = useDispatch();
	const history = useHistory();
	const [expenseList, setExpenseList] = useState([])
	const [isPopUp, setIsPopUp] = useState(false);
	const [loading, setLoading] = useState(false);
	const [expenseData, setExpenseData] = useState({});
	const [isDownloadPopUpOpen, setIsDownloadPopUpOpen] = useState(false);
	const [isNotificationPopupOpen, setIsNotificationPopupOpen] = useState(false);
	const [isSorted, setIsSorted] = useState(false);
	const [dateSortClass, setDateSortClass] = useState('');
	const [typeSortClass, setTypeSortClass] = useState('');
	const [ptSortClass, setPtSortClass] = useState('');
	const [amtSortClass, setAmtSortClass] = useState('');
	const [reimbursableSortClass, setReimbursableSortClass] = useState('');
	const [error, setErrors] = useState(false);
	const refCalendarAction = useRef(null);
	const refFilterAction = useRef(null);
	const [startDate, setStartDate] = useState(new Date());
	const [endDate, setEndDate] = useState(new Date());
	const [printObj, setPrintObj] = useState({});
	const [totalAmt, setTotalAmt] = useState(0);
	const [isResponsiveFilter, setisResponsiveFilter] = useState(false);
	const [isResponsiveCalendar, setisResponsiveCalendar] = useState(false);
	const [loaderFullScreenVisible, setLoaderFullScreenVisible] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	const [message, setMessage] = useState('');
	const startDatesRef = useRef(null);
	const endDatesRef = useRef(null);
	const [selectedTypeFilter, setSelectedTypeFilter] = useState([]);
	const [isFilter, setIsFilter] = useState(false);
	const [typeFilter, setTypeFilter] = useState([]);
	const [isFilterUpdated, setIsFilterUpdated] = useState(false);
	const [selectedReimbursableFilter, setSelectedReimbursableFilter] = useState(null);


	useEffect(() => {
		//setExpenseList(expenseArray)
		setTotalAmt(props.expenseList.length > 0 ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(props.expenseList.map(item => item.amount).reduce((prev, next) => prev + next)) : 0)
		const initilizePrintData = async () => {
			setPrintObj({
				title: A12Y_CONST.LABEL.EXPENSES_LABEL,
				total: totalAmt,
				startDate: await ddmmyyyyFormat(startDate),
				endDate: await ddmmyyyyFormat(endDate),
				dependentName: props.dependent.first_name + ' ' + props.dependent.last_name,
				advocateName: props.userInfo.first_name + ' ' + props.userInfo.last_name,
				totalColor: 'redText',
				totalBg: 'lblTotal'
			})
		}
		initilizePrintData();

	}, [props.expenseList, startDate, endDate, props.dependent.first_name, props.dependent.last_name, props.userInfo.first_name, props.userInfo.last_name, totalAmt])

	useEffect(() => {
		setExpenseList(props.expenseList)
	}, [props.expenseList])

	useEffect(() => {
		if (props.dependent) {
			setStartDate(new Date(props.dependent.reporting_period.start_date));
			setEndDate(new Date(props.dependent.reporting_period.end_date))
		}
	}, [props.dependent])


	function filterExpense(date1, date2, typeFiterExpense) {
		/*const temp = [...expenseList];
 
		let sd = new Date(date1).getTime();
		let ed = new Date(date2).getTime();
		let result = temp.filter(d => {
			var time = new Date(d.date).getTime();
				return (sd < time && time < ed);
			});
 
		setExpenseList(result);*/
		// if(date1 !== null && date2 !== null){
		//
		// }
		//props.onSearch(date1,date2, typeFiterExpense)
		props.setfilter(date1, date2, typeFiterExpense, selectedReimbursableFilter, true)
		setisResponsiveCalendar(false)
	}

	const clearFilter = async () => {
		// await props.updateSelectedFilterTypeList([])
		await setTypeFilter([]);
		await setSelectedTypeFilter([])
		await setSelectedReimbursableFilter(null)
		props.setfilter(props.dependent?.default_reporting_period?.start_date, props.dependent?.default_reporting_period?.end_date, [], null, false);
		setIsFilter(false);
		setStartDate(new Date(props.dependent?.default_reporting_period?.start_date));
		setEndDate(new Date(props.dependent?.default_reporting_period?.end_date));
		await setisResponsiveCalendar(false);
	}

	useEffect(() => {
		//code run on load
		if (props?.filterData['expense']?.reimbursable !== undefined) {
			setSelectedReimbursableFilter(props?.filterData['expense']?.reimbursable);
		}
		if (props?.filterData['expense']?.type.length > 0) {

			let typeFilterCol = []
			props?.filterData['expense'].type?.length > 0 && props.expenseTypeList?.forEach((item) => {
				props?.filterData['expense'].type.forEach((data) => {
					if (data === item.id) {
						typeFilterCol.push(item)
					}
				})
			})
			setTypeFilter(typeFilterCol);
			//filterActivity(startDate, endDate, props?.filterData['activity'].type, props?.filterData['activity'].category_ids)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.expenseTypeList, props.filterData])

	const expenseTypeList = props?.filterData['income'].type
	useEffect(() => {

		const typeFilterResult = JSON.stringify(selectedTypeFilter.sort()) === JSON.stringify(props?.filterData['expense'].type.sort())
		let isTypeFilter
		if (typeFilterResult) {
			isTypeFilter = true
		}
		else {
			isTypeFilter = false
		}
		// function compareArrays(arr1, arr2) {
		//
		// 	// compare arrays
		//
		// }
		//
		// const array1 = [1, 3, 5, 8];
		// const array2 = [8, 1, 3, 5,];
		// compareArrays(array1, array2);

		const reimbursableFilterResult = selectedReimbursableFilter === (props?.filterData['expense']?.reimbursable !== undefined ? props.filterData['expense'].reimbursable : null)

		const updateFilter = async () => {
			let start_Date = await moment(startDate).format("MM/DD/YYYY")
			let end_Date = await moment(endDate).format("MM/DD/YYYY")

			if ((!isTypeFilter) || (!reimbursableFilterResult) || (await props.dependent?.reporting_period?.start_date !== start_Date) || (await props.dependent?.reporting_period?.end_date !== end_Date)) {
				setIsFilterUpdated(true)
			} else {
				setIsFilterUpdated(false)
			}
		}
		updateFilter(); // run it, run it
	}, [isFilterUpdated, selectedTypeFilter, typeFilter, startDate, endDate, props?.filterData, expenseTypeList, props.dependent?.reporting_period?.start_date, props.dependent?.reporting_period?.end_date, selectedReimbursableFilter])

	const expenseTypeLingh = props?.filterData['expense'].type
	useEffect(() => {
		// clear filter button
		const checkFilter = async () => {
			/*let start_Date = await moment(startDate).format("MM/DD/YYYY")
			let end_Date = await moment(endDate).format("MM/DD/YYYY")*/
			const hasReimbursableFilter = props?.filterData['expense']?.reimbursable !== undefined && props.filterData['expense'].reimbursable !== null;
			if (expenseTypeLingh.length > 0 || hasReimbursableFilter || (await props.dependent?.reporting_period?.start_date !== await props.dependent?.default_reporting_period?.start_date) || (await props.dependent?.reporting_period?.end_date !== props.dependent?.default_reporting_period?.end_date)) {
				await setIsFilter(true);
			} else {
				await setIsFilter(false);
			}
		};
		checkFilter(); // run it, run it

	}, [isFilter, startDate, endDate, props?.filterData, props.dependent?.reporting_period?.start_date, props.dependent?.reporting_period?.end_date, expenseTypeLingh, props.dependent?.default_reporting_period?.end_date, props.dependent?.default_reporting_period?.start_date])

	function editExpense(expense) {
		props.onEdit(expense);
	}

	function deleteExpense(expense) {
		setExpenseData(expense)
		setIsPopUp(true)
		//props.onDelete(expense)
	}

	var count = 0;
	const printFromBackEnd = async (includeAttachments = false) => {
		const typeFilterResult = props?.filterData['expense'].type

		try {
			setErrors(false)
			setErrorMessage('')
			await setLoaderFullScreenVisible(true);
			let stDate = await ddmmyyyyFormat(startDate);
			let edDate = await ddmmyyyyFormat(endDate);
			let payload = { "dependent_id": props.dependent.id, "report_type": "expense", "start_date": stDate, "end_date": edDate, "expense_type_ids": typeFilterResult, "include_attachments": includeAttachments };
			const reimbursableVal = props?.filterData['expense']?.reimbursable;
			if (reimbursableVal !== undefined && reimbursableVal !== null) {
				payload.reimbursable = reimbursableVal;
			}
			let response = await secureClient.post('pdf_report', payload);
			if (response.data.status === A12Y_CONST.API_RESPONSE_STATUS.OK) {
				if (includeAttachments) {
					await setLoaderFullScreenVisible(false);
					setIsNotificationPopupOpen(true);
				} else {
					downloadBase64File(response.data.sr.pdf_base64, response.data.file_name)
					await setLoaderFullScreenVisible(false);
				}
			} else {
				setErrors(true)
				setErrorMessage(response.data.sr?.a12yErr?.message || 'Unable to generate pdf report!')
				await setLoaderFullScreenVisible(false);
			}
		} catch (e) {
			count++
			if (count <= 3) {
				printFromBackEnd(includeAttachments)
			} else {
				setErrors(true)
				setErrorMessage(A12Y_CONST.ERROR_MESSAGE.NETWORK_ERROR_TRY_AGAIN)
				await setLoaderFullScreenVisible(false);
				count = 0;
			}
		}
	}

	useEffect(() => {
		setLoading(props.loading)
		setErrors(props.error)
		setErrorMessage(props.errorMessage)
		setMessage(props.message)
	}, [props.loading, props.error, props.message, props.errorMessage])

	function addExpense(params) {
		props.onCreate();
		//history.push('/addExpense')
	}

	function sortBy(sortType) {
		let sortedArray = [];
		const tempArray = [...props.expenseList];
		setTypeSortClass('')
		setDateSortClass('')
		setAmtSortClass('')
		setPtSortClass('')
		setReimbursableSortClass('')

		if (sortType === 'date_of_expense') {
			if (isSorted) {
				sortedArray = tempArray.sort((a, b) => (
					new Date(b['date_of_expense']) - new Date(a['date_of_expense'])
				));
				setDateSortClass('active dec')
				setIsSorted(false)
			} else {
				sortedArray = tempArray.sort((a, b) => (
					new Date(a['date_of_expense']) - new Date(b['date_of_expense'])
				));
				setIsSorted(true)
				setDateSortClass('active asc')
			}
		}
		else {
			if (isSorted) {
				sortedArray = tempArray.sort((a, b) => {
					if (a[sortType] < b[sortType]) {
						return -1;
					}
					if (a[sortType] > b[sortType]) {
						return 1;
					}
					return 0;
				});
				setIsSorted(false)
				if (sortType === 'expense_type') {
					setTypeSortClass('active asc')
				} else if (sortType === 'paid_to') {
					setPtSortClass('active asc')
				} else if (sortType === 'reimbursable') {
					setReimbursableSortClass('active asc')
				} else {
					setAmtSortClass('active asc')

				}

			} else {
				sortedArray = tempArray.sort((b, a) => {
					if (a[sortType] < b[sortType]) {
						return -1;
					}
					if (a[sortType] > b[sortType]) {
						return 1;
					}
					return 0;
				});
				setIsSorted(true)
				if (sortType === 'expense_type') {
					setTypeSortClass('active dec')
				} else if (sortType === 'paid_to') {
					setPtSortClass('active dec')
				} else if (sortType === 'reimbursable') {
					setReimbursableSortClass('active dec')
				} else {
					setAmtSortClass('active dec')
				}
			}
		}
		setExpenseList(sortedArray)
		setisResponsiveFilter(false)
	}

	const hidePopUp = () => {
		setIsPopUp(false)
	}
	const handleDeleteButton = () => {
		setIsPopUp(false)
		props.onDelete(expenseData)
	}

	const setStartingDate = (date) => {
		setStartDate(date)
		if (date !== null && date.getTime() > endDate.getTime()) {
			setEndDate(date)
		}
	}

	const setEndingDate = (date) => {
		// if(date.getTime() > new Date().getTime() || startDate.getTime() > date.getTime()){
		//     setEndDate(new Date())
		// }else {
		//     setEndDate(date)
		// }

		//setEndDate(date)

		if (new Date(startDate) < new Date(date)) {
			setEndDate(date)
		}
	}

	function viewDetails(expense) {
		props.onView(expense)
	}

	const handleChangeRaw = (e, elmName) => {
		let val = e.target.value
		if (typeof val !== 'object' && val !== undefined) {
			document.getElementsByName(elmName)[0].value = (dateFromKeyboard(val)).toString().replace(/ /g, '')
		}
	}

	const showFilter = () => {
		setisResponsiveFilter(!isResponsiveFilter)
	}
	const showCalendar = async () => {
		await setSelectedTypeFilter(props?.filterData['expense'].type)
		setisResponsiveCalendar(!isResponsiveCalendar)
		let arr = [startDatesRef.current, endDatesRef.current]
		readOnlyMobile(arr);
		if (!isResponsiveCalendar && props.dependent?.id) {
			let typeFilterCol = []
			props?.filterData['expense'].type?.length > 0 && props.expenseTypeList?.forEach((item) => {
				props?.filterData['expense'].type.forEach((data) => {
					if (data === item.id) {
						typeFilterCol.push(item)
					}
				})
			})
			setTypeFilter(typeFilterCol);
			// dispatch(getExpenseTypeList(props.dependent.id));
		}
	}
	const hideCalendar_Filter = async (event) => {
		// if(isResponsiveFilter || isResponsiveCalendar){
		// 	setisResponsiveFilter(false)
		// }
		if (refCalendarAction.current && !refCalendarAction.current.contains(event.target)) {
			setisResponsiveCalendar(false)
			await filterPopUpClose();
		}
		if (refFilterAction.current && !refFilterAction.current.contains(event.target)) {
			setisResponsiveFilter(false)
		}
	}
	useEffect(() => {
		document.addEventListener('click', hideCalendar_Filter, true);
		return () => {
			document.removeEventListener('click', hideCalendar_Filter, true);
		};
	});

	const goToExpenseLandingPage = async () => {
		props.goToExpenseLandingPage();
	}



	const onSelect = (selectedList, selectedItem) => {
		selectedTypeList(selectedList)
	}
	const onRemove = (selectedList, removedItem) => {
		selectedTypeList(selectedList)
	}

	const selectedTypeList = async (selectedList) => {
		var listactiveType = [];
		selectedList.forEach((type) => {
			listactiveType.push(type.id)
		})
		setSelectedTypeFilter(listactiveType)
		await setTypeFilter(selectedList);
	}

	const filterPopUpClose = async () => {
		setStartDate(new Date(props.dependent.reporting_period.start_date));
		setEndDate(new Date(props.dependent.reporting_period.end_date))
		setSelectedReimbursableFilter(props?.filterData['expense']?.reimbursable !== undefined ? props.filterData['expense'].reimbursable : null);

		let typeFilterCol = []
		props?.filterData['expense'].type?.length > 0 && props.expenseTypeList?.forEach((item) => {
			props?.filterData['expense'].type.forEach((data) => {
				if (data === item.id) {
					typeFilterCol.push(item)
				}
			})
		})
		setTypeFilter(typeFilterCol);
		setisResponsiveCalendar(false)
	}
	return (
		<div>
			{loaderFullScreenVisible ?
				<LoaderFullScreen />
				:
				null
			}
			<h2 className="titleWithSidebar responsiveListTitle overViewLabel expenseTitleMargin marginBottom30 expenseListError">
				{error ?
					<div className='maxWidth600 marginLeftRightAuto'>
						<ErrorMessageComponent errorMessage={errorMessage} />
					</div>
					:
					(message ?
						<SuccessMessageComponent successMessage={message} />

						:
						null
					)

				}
				<div className='fullWidth600Col'>
					<span>{props.dependent.first_name}'s {A12Y_CONST.LABEL.EXPENSES_LABEL}</span>
					<span id={A12Y_CONST.BUTTON_ID.LEARN_MORE + A12Y_CONST.LABEL.EXPENSE_LABEL} onClick={() => { goToExpenseLandingPage() }} className="titleRightContent2 positionAbsoute">{A12Y_CONST.LABEL.LEARN_MORE}</span>
				</div>
			</h2>
			<div className="padding20 fullWidth responsiveListTableTop expenseBoxCol">
				<link rel='stylesheet' type='text/css' media='print' href='/src/assets/css/print.css' />
				{/* <div className='printTop df fcol'>
					<div className='df paddingBottom10'>
						<div className='printLogo'>
							<img class="animationall" src="data:image/png;base64,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" alt="logo" />	
						</div>
						<div className='dependent mla text20 tar marginTop10'>{A12Y_CONST.LABEL.ADVOCATE}: {'Advocate name'}</div>	
					</div>
					<div className='df paddingBottom10'>
						<div><b className='text24'>{A12Y_CONST.LABEL.EXPENSES_LABEL}</b></div>
						<div className='dependent mla text20 tar'>{A12Y_CONST.LABEL.DEPENDENT}: {props.dependent.first_name + ' ' + props.dependent.last_name}</div>	
					</div>
				</div> */}
				{loading ?
					null
					:
					<div className="tableTop tableTopMain df aic pb10">
						{/*<div className="tableTopLeft df aic">*/}
						{/*	<span className='onlyForPrint'>{A12Y_CONST.LABEL.FROM} </span>*/}
						{/*	<span className={'icoWrap ' + (isResponsiveCalendar && 'thisActive')}>*/}
						{/*		<span onClick={showCalendar} className="a12-icon dateIcon notToPrint">*/}
						{/*			<svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
						{/*				<path fillRule="evenodd" clipRule="evenodd" d="M1 4.99997C1 3.8954 1.89543 2.99997 3 2.99997H17C18.1046 2.99997 19 3.8954 19 4.99997V19C19 20.1046 18.1046 21 17 21H3C1.89543 21 1 20.1046 1 19V4.99997Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />*/}
						{/*				<path d="M14.0002 1V5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />*/}
						{/*				<path d="M5.99976 1V5"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />*/}
						{/*				<path d="M1 8.99994H19"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />*/}
						{/*			</svg>*/}
						{/*		</span>*/}
						{/*		<i></i>*/}
						{/*	</span>*/}
						{/*	<span className={'icoWrap ' + (isResponsiveFilter && 'thisActive')}>*/}
						{/*		<span onClick={showFilter} className="a12-icon filterIcon notToPrint marginLeft10 hideDesktopShowMobile">*/}
						{/*			<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
						{/*				<path d="M9.00781 15.0029L1.00781 15.0067" stroke="white" strokeWidth="1.3" strokeLinecap="round"/>*/}
						{/*				<path d="M17.001 2.99902L14.001 3.00046" stroke="white" strokeWidth="1.3" strokeLinecap="round"/>*/}
						{/*				<path d="M17.0078 14.999L13.0078 15.0009" stroke="white" strokeWidth="1.3" strokeLinecap="round"/>*/}
						{/*				<path d="M10.001 3.00293L1.00098 3.00722" stroke="white" strokeWidth="1.3" strokeLinecap="round"/>*/}
						{/*				<path d="M4.00439 9.00586L1.00439 9.00729" stroke="white" strokeWidth="1.3" strokeLinecap="round"/>*/}
						{/*				<path d="M17.0044 8.99902L8.0044 9.00332" stroke="white" strokeWidth="1.3" strokeLinecap="round"/>*/}
						{/*				<circle cx="11.0078" cy="15.002" r="2" transform="rotate(-90.0273 11.0078 15.002)" stroke="white" strokeWidth="1.3" strokeLinecap="round"/>*/}
						{/*				<circle cx="6.00442" cy="9.00491" r="2" transform="rotate(-90.0273 6.00442 9.00491)" stroke="white" strokeWidth="1.3" strokeLinecap="round"/>*/}
						{/*				<circle cx="12.001" cy="3.00198" r="2" transform="rotate(-90.0273 12.001 3.00198)" stroke="white" strokeWidth="1.3" strokeLinecap="round"/>*/}
						{/*			</svg>*/}
						{/*		</span>*/}
						{/*		<i></i>*/}
						{/*	</span>*/}
						{/*	<span onClick={() => printFromBackEnd('Printable', printObj)} className="a12-icon printIcon notToPrint marginLeft10 hideDesktopShowMobile">*/}
						{/*	<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">*/}
						{/*		<path d="M8.13504 9.42846C7.81509 9.12375 7.30871 9.13611 7.004 9.45605C6.69929 9.77599 6.71164 10.2824 7.03159 10.5871L8.13504 9.42846ZM13 15.1665L12.4483 15.7458L13 16.2713L13.5517 15.7458L13 15.1665ZM18.9684 10.5871C19.2883 10.2824 19.3007 9.77599 18.996 9.45605C18.6912 9.13611 18.1849 9.12375 17.8649 9.42846L18.9684 10.5871ZM13.8 4.33317C13.8 3.89134 13.4418 3.53317 13 3.53317C12.5582 3.53317 12.2 3.89134 12.2 4.33317L13.8 4.33317ZM7.03159 10.5871L12.4483 15.7458L13.5517 14.5872L8.13504 9.42846L7.03159 10.5871ZM13.5517 15.7458L18.9684 10.5871L17.8649 9.42846L12.4483 14.5872L13.5517 15.7458ZM13.8 15.1665L13.8 4.33317L12.2 4.33317L12.2 15.1665L13.8 15.1665Z" fill="white"/>*/}
						{/*		<path d="M5.41669 17.3335L5.41669 18.4168C5.41669 19.6134 6.38674 20.5835 7.58335 20.5835L18.4167 20.5835C19.6133 20.5835 20.5834 19.6134 20.5834 18.4168V17.3335" stroke="white" strokeWidth="1.6" strokeLinecap="round"/>*/}
						{/*	</svg>*/}
						{/*</span>*/}
						{/*	<div ref={refCalendarAction} className={`dateWrap df aic ${isResponsiveCalendar?'calendarDisplayBlock':null}`}>*/}
						{/*		<h3 className='filterByDate hideDesktopShowMobile'>{A12Y_CONST.LABEL.FILTER_BY_DATE}</h3>*/}
						{/*		<span className='fromText hideDesktopShowMobile'>{A12Y_CONST.LABEL.FROM} </span>*/}
						{/*		<div className="dateStart">*/}
						{/*			<DatePicker*/}
						{/*				name='startDate'*/}
						{/*				ref={startDatesRef}*/}
						{/*				selected={startDate}*/}
						{/*				onChange={setStartingDate}*/}
						{/*				onChangeRaw={(event) => handleChangeRaw(event, 'startDate')}*/}
						{/*				onBlur={()=>{*/}
						{/*					if(startDate === null){*/}
						{/*						setStartDate(new Date(props.dependent.reporting_period.start_date));*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				// onCalendarClose={handleStatDateChange}*/}
						{/*				showMonthDropdown*/}
						{/*				showYearDropdown*/}
						{/*				// onFocus={e => readOnlyOnMobile(e.target)}*/}
						{/*				dropdownMode="select"*/}
						{/*			/>*/}
						{/*		</div>*/}
						{/*		<div className="txtTo">{A12Y_CONST.LABEL.TO}</div>*/}
						{/*		<div className="dateEnd">*/}
						{/*			<DatePicker*/}
						{/*				name='endDate'*/}
						{/*				ref={endDatesRef}*/}
						{/*				selected={endDate}*/}
						{/*				minDate={startDate}*/}
						{/*				onChange={setEndingDate}*/}
						{/*				onChangeRaw={(event) => handleChangeRaw(event, 'endDate')}*/}
						{/*				onBlur={()=>{*/}
						{/*					if (endDate === null){*/}
						{/*						setEndDate(new Date(props.dependent.reporting_period.end_date))*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				// onCalendarClose={handleEndDateChange}*/}
						{/*				// onFocus={e => readOnlyOnMobile(e.target)}*/}
						{/*				showMonthDropdown*/}
						{/*				showYearDropdown*/}
						{/*				dropdownMode="select"*/}
						{/*			/>*/}
						{/*		</div>*/}
						{/*		<div className='marginLeft10 notToPrint dateColButonRow'>*/}
						{/*			<button className="btn-outline btn-md saveButton filterCancelButton hideDesktopShowMobile" onClick={() => setisResponsiveCalendar(false)} >{A12Y_CONST.BUTTON_TEXT.CANCEL}</button>*/}
						{/*			<button className="btn-outline btn-md saveButton filterButton" onClick={() => filterExpense(startDate, endDate)}>{A12Y_CONST.TEXT.FILTER}</button>*/}
						{/*		</div>*/}
						{/*	</div>*/}
						{/*	{isResponsiveFilter &&*/}
						{/*	<div ref={refFilterAction}  className={`filterDorpDownMain hideDesktopShowMobile ${isResponsiveFilter?'displayBlock':null}`}>*/}
						{/*		<h3>{A12Y_CONST.LABEL.SORT_BY}</h3>*/}
						{/*		<ul>*/}
						{/*			<li><span onClick={() => sortBy('date_of_expense')} className={`${dateSortClass} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.DATE} <i className="arrow down"></i></span></li>*/}
						{/*			<li><span onClick={() => sortBy('paid_to')} className={`${ptSortClass} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.PAID_TO} <i className="arrow down"></i></span></li>*/}
						{/*			<li><span onClick={() => sortBy('amount')} className={`${amtSortClass} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.AMOUNT} <i className="arrow down"></i></span></li>*/}
						{/*			<li><span onClick={() => sortBy('expense_type')} className={`${typeSortClass} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.TYPE} <i className="arrow down"></i></span></li>*/}
						{/*		</ul>*/}
						{/*	</div>*/}
						{/*	}*/}
						{/*</div>*/}
						<div className="tableTopLeft incomeTableTopLeft df aic">
							<span className={'icoWrap ' + (isResponsiveFilter && 'thisActive')}>
								<span onClick={showFilter} className="a12-icon filterIcon notToPrint marginRight10 hideDesktopShowMobile">
									{
										window.innerWidth > 768 ?
											<svg xmlns="http://www.w3.org/2000/svg" width="19" height="21" viewBox="0 0 19 21" fill="none">
												<path d="M9.00684 3.02734L17.0068 2.99987" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round" />
												<path d="M1.00684 3.05493L5.00681 3.04119" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round" />
												<circle cx="7.00688" cy="3.03444" r="2" transform="rotate(89.8032 7.00688 3.03444)" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round" />
												<path d="M14.0308 10.0103L17.0307 9.99995" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round" />
												<path d="M1.03076 10.0549L9.03071 10.0275" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round" />
												<circle cx="12.0308" cy="10.0171" r="2" transform="rotate(89.8032 12.0308 10.0171)" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round" />
												<path d="M1.05469 17.0549L3.05468 17.0481" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round" />
												<path d="M9.05469 17.0273L17.0546 16.9999" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round" />
												<circle cx="6.05473" cy="17.0379" r="2" transform="rotate(89.8032 6.05473 17.0379)" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round" />
											</svg>
											:
											<svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M1.6001 1H18.4001" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
												<path d="M1.6001 6H13.6001" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
												<path d="M1.6001 11H8.8001" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
											</svg>
									}
								</span>
								<i></i>
							</span>
							<span id={A12Y_CONST.LABEL.FILTERS + A12Y_CONST.LABEL.EXPENSE_LABEL} className={'icoWrap filterTextIconColoum ' + (isResponsiveCalendar && 'thisActive')}>
								<span onClick={showCalendar} className={'a12-icon dateIcon'} id='dateIcon'>
									{
										window.innerWidth > 768 ?
											<>
												{
													isFilter ?
														<svg xmlns="http://www.w3.org/2000/svg" width="19" height="21" viewBox="0 0 19 21" fill="none">
															<path d="M9.00684 3.02734L17.0068 2.99987" stroke="#D96941" strokeWidth="2" strokeLinecap="round" />
															<path d="M1.00684 3.05493L5.00681 3.04119" stroke="#D96941" strokeWidth="2" strokeLinecap="round" />
															<circle cx="7.00688" cy="3.03444" r="2" transform="rotate(89.8032 7.00688 3.03444)" stroke="#D96941" strokeWidth="2" strokeLinecap="round" />
															<path d="M14.0308 10.0103L17.0307 9.99995" stroke="#D96941" strokeWidth="2" strokeLinecap="round" />
															<path d="M1.03076 10.0549L9.03071 10.0275" stroke="#D96941" strokeWidth="2" strokeLinecap="round" />
															<circle cx="12.0308" cy="10.0171" r="2" transform="rotate(89.8032 12.0308 10.0171)" stroke="#D96941" strokeWidth="2" strokeLinecap="round" />
															<path d="M1.05469 17.0549L3.05468 17.0481" stroke="#D96941" strokeWidth="2" strokeLinecap="round" />
															<path d="M9.05469 17.0273L17.0546 16.9999" stroke="#D96941" strokeWidth="2" strokeLinecap="round" />
															<circle cx="6.05473" cy="17.0379" r="2" transform="rotate(89.8032 6.05473 17.0379)" stroke="#D96941" strokeWidth="2" strokeLinecap="round" />
														</svg>
														:
														<svg xmlns="http://www.w3.org/2000/svg" width="19" height="21" viewBox="0 0 19 21" fill="none">
															<path d="M9.00684 3.02734L17.0068 2.99987" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round" />
															<path d="M1.00684 3.05493L5.00681 3.04119" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round" />
															<circle cx="7.00688" cy="3.03444" r="2" transform="rotate(89.8032 7.00688 3.03444)" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round" />
															<path d="M14.0308 10.0103L17.0307 9.99995" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round" />
															<path d="M1.03076 10.0549L9.03071 10.0275" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round" />
															<circle cx="12.0308" cy="10.0171" r="2" transform="rotate(89.8032 12.0308 10.0171)" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round" />
															<path d="M1.05469 17.0549L3.05468 17.0481" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round" />
															<path d="M9.05469 17.0273L17.0546 16.9999" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round" />
															<circle cx="6.05473" cy="17.0379" r="2" transform="rotate(89.8032 6.05473 17.0379)" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round" />
														</svg>
												}
											</>
											:
											<svg xmlns="http://www.w3.org/2000/svg" width="19" height="21" viewBox="0 0 19 21" fill="none">
												<path d="M9.00684 3.02734L17.0068 2.99987" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
												<path d="M1.00684 3.05493L5.00681 3.04119" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
												<circle cx="7.00688" cy="3.03444" r="2" transform="rotate(89.8032 7.00688 3.03444)" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
												<path d="M14.0308 10.0103L17.0307 9.99995" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
												<path d="M1.03076 10.0549L9.03071 10.0275" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
												<circle cx="12.0308" cy="10.0171" r="2" transform="rotate(89.8032 12.0308 10.0171)" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
												<path d="M1.05469 17.0549L3.05468 17.0481" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
												<path d="M9.05469 17.0273L17.0546 16.9999" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
												<circle cx="6.05473" cy="17.0379" r="2" transform="rotate(89.8032 6.05473 17.0379)" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
											</svg>
									}
									<span className={`filterText ${isFilter ? 'filterTextActive' : ''}`}>{A12Y_CONST.LABEL.FILTER}</span>
								</span>
								<i></i>
							</span>
							{isResponsiveCalendar || isResponsiveFilter ?
								<div className="orerlayFilter"></div>
								:
								null
							}
							<span className={'icoWrap calendarDateCol ' + (isResponsiveCalendar && 'thisActive')}>
								<span className={'a12-icon dateIcon startEndDateReadOnly'}>
									{/*<span className='rangeText'>{A12Y_CONST.LABEL.RANGE}</span>*/}
									<div><span>{A12Y_CONST.LABEL.FROM_COLON}</span> {moment(startDate).format("MMM DD,YYYY")} <span>{A12Y_CONST.LABEL.TO_COLON}</span> {moment(endDate).format("MMM DD,YYYY")} </div>
								</span>
								<i></i>
							</span>
							<span onClick={() => setIsDownloadPopUpOpen(true)} className={`a12-icon printIcon notToPrint marginLeft10 hideDesktopShowMobile ${expenseList.length === 0 ? 'clickDisable' : ''}`}>
								<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
									<path d="M8.13504 9.42846C7.81509 9.12375 7.30871 9.13611 7.004 9.45605C6.69929 9.77599 6.71164 10.2824 7.03159 10.5871L8.13504 9.42846ZM13 15.1665L12.4483 15.7458L13 16.2713L13.5517 15.7458L13 15.1665ZM18.9684 10.5871C19.2883 10.2824 19.3007 9.77599 18.996 9.45605C18.6912 9.13611 18.1849 9.12375 17.8649 9.42846L18.9684 10.5871ZM13.8 4.33317C13.8 3.89134 13.4418 3.53317 13 3.53317C12.5582 3.53317 12.2 3.89134 12.2 4.33317L13.8 4.33317ZM7.03159 10.5871L12.4483 15.7458L13.5517 14.5872L8.13504 9.42846L7.03159 10.5871ZM13.5517 15.7458L18.9684 10.5871L17.8649 9.42846L12.4483 14.5872L13.5517 15.7458ZM13.8 15.1665L13.8 4.33317L12.2 4.33317L12.2 15.1665L13.8 15.1665Z" fill="white" />
									<path d="M5.41669 17.3335L5.41669 18.4168C5.41669 19.6134 6.38674 20.5835 7.58335 20.5835L18.4167 20.5835C19.6133 20.5835 20.5834 19.6134 20.5834 18.4168V17.3335" stroke="white" strokeWidth="1.6" strokeLinecap="round" />
								</svg>
							</span>
							<div ref={refCalendarAction} className={`dateWrap df aic ${isResponsiveCalendar ? 'calendarDisplayBlock' : null}`}>
								<h3 className='filterByDate'>{A12Y_CONST.LABEL.FILTERS} <span id={A12Y_CONST.BUTTON_ID.CROSS + A12Y_CONST.LABEL.FILTERS} onClick={() => filterPopUpClose()} className={`clearTextInFilterCol`}><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none"> <path d="M6.5 5.05908L11.5558 0L13 1.44117L7.94422 6.5L13 11.5588L11.5558 13L6.5 7.94092L1.44422 13L0 11.5588L5.05578 6.5L0 1.44117L1.44422 0L6.5 5.05908Z" fill="#71767A" /></svg></span></h3>
								<div className="fullWidth dateStartEnd">
									<div className="dateStart">
										<div className="txtTo">{A12Y_CONST.LABEL.FROM}</div>
										<DatePicker
											name='startDate'
											ref={startDatesRef}
											selected={startDate}
											onChange={setStartingDate}
											onChangeRaw={(event) => handleChangeRaw(event, 'startDate')}
											onBlur={() => {
												if (startDate === null) {
													setStartDate(new Date(props.dependent.reporting_period.start_date));
												}
											}}
											// onCalendarClose={handleStatDateChange}
											showMonthDropdown
											// onFocus={e => readOnlyOnMobile(e.target)}
											showYearDropdown
											dropdownMode="select"
											onMonthChange={setStartingDate}
											onYearChange={setStartingDate}
										/>
									</div>
									<div className="dateEnd">
										<div className="txtTo">{A12Y_CONST.TEXT.to}</div>
										<DatePicker
											name='endDate'
											ref={endDatesRef}
											selected={endDate}
											minDate={startDate}
											onChange={setEndingDate}
											onChangeRaw={(event) => handleChangeRaw(event, 'endDate')}
											onBlur={() => {
												if (endDate === null) {
													setEndDate(new Date(props.dependent.reporting_period.end_date))
												}
											}}
											// onCalendarClose={handleEndDateChange}
											// onFocus={e => readOnlyOnMobile(e.target)}
											showMonthDropdown
											showYearDropdown
											dropdownMode="select"
											onMonthChange={setEndingDate}
											onYearChange={setEndingDate}
										/>
									</div>
								</div>
								<div className='fullWidth typeTitleFilter'>
									<div className="txtTo fullWidth" style={{ marginBottom: '12px' }}>
										Reimbursable
									</div>
									<div className="reimbursable-btn-group fullWidth df aic" role="group" aria-label="Filter by Reimbursable">

										<button
											id="reimbursable-filter-yes"
											type="button"
											className={`reimbursable-btn ${selectedReimbursableFilter === true ? 'active' : ''}`}
											onClick={() => setSelectedReimbursableFilter(true)}
											aria-pressed={selectedReimbursableFilter === true}
										>
											Yes
										</button>
										<button
											id="reimbursable-filter-no"
											type="button"
											className={`reimbursable-btn ${selectedReimbursableFilter === false ? 'active' : ''}`}
											onClick={() => setSelectedReimbursableFilter(false)}
											aria-pressed={selectedReimbursableFilter === false}
										>
											No
										</button>
										<button
											id="reimbursable-filter-all"
											type="button"
											className={`reimbursable-btn ${selectedReimbursableFilter === null ? 'active' : ''}`}
											onClick={() => setSelectedReimbursableFilter(null)}
											aria-pressed={selectedReimbursableFilter === null}
										>
											All
										</button>
									</div>
								</div>
								<div className='fullWidth typeTitleFilter'>
									<div className="txtTo fullWidth">
										{A12Y_CONST.LABEL.CATEGORY}
									</div>
									<div className="fullWidth typeListFilter padding20">
										<Multiselect
											options={props.expenseTypeList} // Options to display in the dropdown
											selectedValues={typeFilter} // Preselected value to persist in dropdown
											onSelect={onSelect} // Function will trigger on select event
											onRemove={onRemove} // Function will trigger on remove event
											displayValue="title" // Property name to display in the dropdown options
											showCheckbox
											avoidHighlightFirstOption={false}
										/>

									</div>
								</div>

								<div className='marginLeft10 filterButtonRow fullWidth dateColButonRow'>
									<button id={A12Y_CONST.LABEL.FILTERS + A12Y_CONST.LABEL.CLEAR + A12Y_CONST.LABEL.EXPENSE_LABEL} className={`btn-outline btn-md saveButton filterCancelButton ${isFilter ? 'buttonActive' : ''}`} onClick={clearFilter} >{A12Y_CONST.LABEL.CLEAR}</button>
									<button id={A12Y_CONST.LABEL.FILTERS + A12Y_CONST.LABEL.APPLY + A12Y_CONST.LABEL.EXPENSE_LABEL} className={`btn-outline btn-md saveButton filterButton ${isFilterUpdated ? 'applybuttonActive' : ''}`} onClick={() => filterExpense(startDate, endDate, selectedTypeFilter)}>{A12Y_CONST.TEXT.APPLY}</button>
								</div>
							</div>
							{isResponsiveFilter &&
								<div ref={refFilterAction} className={`filterDorpDownMain hideDesktopShowMobile ${isResponsiveFilter ? 'displayBlock' : null}`}>
									<h3>{A12Y_CONST.LABEL.SORT_BY}</h3>
									<ul>
										<li><span onClick={() => sortBy('date_of_expense')} className={`${dateSortClass} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.DATE} <i className="arrow down"></i></span></li>
										<li><span onClick={() => sortBy('expense_type')} className={`${typeSortClass} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.TYPE} <i className="arrow down"></i></span></li>
										<li><span onClick={() => sortBy('amount')} className={`${amtSortClass} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.AMOUNT} <i className="arrow down"></i></span></li>
									</ul>
								</div>
							}
						</div>

						<div className="tableTopRight df mla">
							<span className="lblTotal marginRight20 df aic jcc">Total: <span className="marginLeft10 redText">{totalAmt}</span></span>
							<button disabled={expenseList.length === 0 ? true : false} id={A12Y_CONST.BUTTON_ID.DOWNLOAD_EXPENSE} className={`btn-outline saveButton marginRight20 displayNone600 notToPrint printButton ${loading ? 'clickDisable' : ''}`} onClick={() => setIsDownloadPopUpOpen(true)}>{A12Y_CONST.TEXT.DOWNLOAD}</button>
							{props.dependent?.access && props.dependent.access.can_update === true ?
								<button id={A12Y_CONST.BUTTON_ID.ADD_EXPENSE} className={`btn-primary saveButton plusIcon notToPrint ${loading ? 'clickDisable' : ''}`} onClick={addExpense}><span>{A12Y_CONST.TEXT.PLUS_SYMBOL}</span> <span className='displayNone600' >{A12Y_CONST.LABEL.EXPENSE_LABEL}</span></button>
								:
								null
							}
						</div>
					</div>
				}
				<div className="tableBody responsiveTalbe expenseTableTitle marginTop20" id='Printable'>
					{
						loading ?
							<div className='noData df aic jcc fcol'>
								<div className="positionRelative">
									<div className="dependentLoader">
										<div className='fullWidth justifyCenter marginBottom10'>
											<div className="stage">
												<div className="dot-pulse"></div>
											</div>
										</div>
									</div>
									<div className='marginTop20'>
										<span>{A12Y_CONST.TEXT.LOADING_EXPENSES}</span>
									</div>
								</div>
							</div>
							:
							expenseList.length === 0 ?
								<div className='noData df aic jcc fcol'>
									<strong>{A12Y_CONST.TEXT.NO_DATA_FOUND}</strong>
									<p>{A12Y_CONST.TEXT.NO_DATA_FOUND_MESSAGE}</p>
								</div>
								:
								<table cellSpacing="0" cellPadding="0" width='100%' className={`fullWidth table ${expenseList.length === 0 ? 'notToPrint' : ''}`} id="TableContent">
									<thead className='mt20'>
										<tr>
											<th className='dateCol'><span onClick={() => sortBy('date_of_expense')} className={`${dateSortClass} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.DATE} <i className="arrow down"></i></span></th>
											<th className='typeCol'><span onClick={() => sortBy('expense_type')} className={`${typeSortClass} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.EXPENSE_CATEGORY} <i className="arrow down"></i></span></th>
											<th><span onClick={() => sortBy('paid_to')} className={`${ptSortClass} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.PAID_TO} <i className="arrow down"></i></span></th>
											<th className='reimbursableCol'><span onClick={() => sortBy('reimbursable')} className={`${reimbursableSortClass} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.REIMBURSABLE} <i className="arrow down"></i></span></th>
											<th className='amtCol'><span onClick={() => sortBy('amount')} className={`${amtSortClass} filterBy df aic cursorPointer tar-print`}>{A12Y_CONST.LABEL.AMOUNT} <i className="arrow down"></i></span></th>
											<th className='actCol notToPrint'></th>
										</tr>
									</thead>
									<tbody>
										{expenseList.map((item, i) => {
											return (
												<tr key={i}>
													<td><span onClick={() => viewDetails(item)} className="h100 df aic cursorPointer"> {item.date_of_expense ? moment(new Date(item.date_of_expense)).format("MM/DD/YYYY") : null}</span></td>
													<td className='ellipsis'><span onClick={() => viewDetails(item)} className="h100 df aic cursorPointer"> {item.expense_type}</span></td>
													<td className='ellipsis'><span onClick={() => viewDetails(item)} className="h100 df aic cursorPointer"> {item.paid_to}</span></td>
													<td><span onClick={() => viewDetails(item)} className="h100 df aic cursorPointer">{item.reimbursable ? A12Y_CONST.LABEL.YES : A12Y_CONST.LABEL.NO}</span></td>
													<td><span onClick={() => viewDetails(item)} className="h100 df aic cursorPointer nowrap tar-print">{amoutWithoutDecimal(item.amount)}</span></td>
													<td className="tac tdAction textAlignRight notToPrint">
														{props.dependent?.access && props.dependent.access.can_update === true
															?
															<div className='activityButonAction'>
																<span id={A12Y_CONST.LABEL.EXPENSES_LABEL + A12Y_CONST.TEXT.EDIT + item.id} className="marginRight10" onClick={() => editExpense(item)}>
																	<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
																		<path d="M13.293 0.292875C13.683 -0.097625 14.317 -0.097625 14.707 0.292875L18.707 4.29287C19.098 4.68337 19.098 5.31657 18.707 5.70707L5.707 18.7071C5.52 18.8946 5.265 19 5 19H1C0.4477 19 0 18.5523 0 18V14C0 13.7348 0.1054 13.4804 0.2929 13.2929L10.293 3.29307L13.293 0.292875ZM11 5.41417L2 14.4142V17H4.586L13.586 7.99997L11 5.41417ZM15 6.58577L16.586 4.99997L14 2.41417L12.414 3.99997L15 6.58577Z" fill="#2D6CB2" />
																	</svg>
																</span>
																<span id={A12Y_CONST.LABEL.EXPENSE_LABEL + A12Y_CONST.TEXT.DELETE + item.id} className="marginLeft10 deleteIcon" onClick={() => deleteExpense(item)}>
																	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
																		<path d="M5 2C5 0.8954 5.89543 0 7 0H13C14.1046 0 15 0.8954 15 2V4H16.9897C16.9959 3.9999 17.0021 3.9999 17.0083 4H19C19.5523 4 20 4.4477 20 5C20 5.5523 19.5523 6 19 6H17.9311L17.0638 18.1425C16.989 19.189 16.1182 20 15.0689 20H4.93112C3.88184 20 3.01096 19.189 2.9362 18.1425L2.06888 6H1C0.44772 6 0 5.5523 0 5C0 4.4477 0.44772 4 1 4H2.99174C2.99795 3.9999 3.00414 3.9999 3.01032 4H5V2ZM7 4H13V2H7V4ZM4.07398 6L4.93112 18H15.0689L15.926 6H4.07398ZM8 8C8.5523 8 9 8.4477 9 9V15C9 15.5523 8.5523 16 8 16C7.44772 16 7 15.5523 7 15V9C7 8.4477 7.44772 8 8 8ZM12 8C12.5523 8 13 8.4477 13 9V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V9C11 8.4477 11.4477 8 12 8Z" fill="#D96941" />
																	</svg>
																</span>
																<span onClick={() => viewDetails(item)} className="marginLeft10 ViewIcon">
																	<img src={viewIcon} alt='View Icon' />
																</span>
															</div>
															:
															null
														}
													</td>
												</tr>
											)
										})}
									</tbody>
									<tfoot><tr><td><div className="footer-space">&nbsp;</div></td></tr></tfoot>
								</table>
					}
				</div>
			</div>
			<PopUpIncomeExpComponent
				popUpStatus={isPopUp}
				title={A12Y_CONST.TEXT.ARE_YOU_SURE_YOU_WANT_TO_DELETE_TEXT}
				message={A12Y_CONST.LABEL.ANY_EDITS_YOU}
				buttonDeleteTxt={A12Y_CONST.BUTTON_TEXT.YES}
				buttonCancelTxt={A12Y_CONST.BUTTON_TEXT.NO}
				hidePopUp={hidePopUp}
				handleDeleteButton={handleDeleteButton}
			/>
			<DownloadPopupComponent
				isOpen={isDownloadPopUpOpen}
				onClose={() => setIsDownloadPopUpOpen(false)}
				onConfirm={(fields) => {
					setIsDownloadPopUpOpen(false);
					printFromBackEnd(fields.includeAttachments);
				}}
			/>
			<ReportProcessingPopupComponent
				isOpen={isNotificationPopupOpen}
				onClose={() => setIsNotificationPopupOpen(false)}
			/>
		</div>
	)
}

export default ExpenseListComponent